"use client";

import { useSelector } from "react-redux";

import AcoSection from "@/components/organisms/quote/acos/aco-section";
import { RootState } from "@/store/root-reducer";
import { OptionalExtra } from "@/types/OptionalExtraType";
import { AcoSectionContentType } from "@/utils/schema/quote-page-schema.utils";

import NoAcoSection from "./no-aco-section/no-aco-section";

function RenewalAcoSection({
  acoSectionContent,
}: Readonly<{ acoSectionContent: AcoSectionContentType | null }>) {
  const { attributes } = useSelector((state: RootState) => state.quote);
  const { priceResult } = attributes;
  if (
    priceResult?.optionalExtras.filter(
      (value: OptionalExtra) => value.price[0].state === "ENABLED"
    ).length === 0
  ) {
    return (
      <NoAcoSection
        policyExtraDescription={acoSectionContent?.policyExtraDescription ?? ""}
        policyExtraTitle={acoSectionContent?.policyExtraTitle ?? ""}
      />
    );
  }
  return <AcoSection acoSectionContent={acoSectionContent} />;
}

export default RenewalAcoSection;
